import {
  MonthlyRent,
  RentalProduct,
} from "Store/interfaces/products/checkout/riskProducts/houseProducts/RentalProduct";

import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";

export const rentalDetailsList = (product: RentalProduct): ProductDetail[] => {
  return [
    {
      name: "monthlyRent",
      value: monthlyRentValue(product.monthlyRent),
    },
  ];
};

const monthlyRentValue = (monthlyRent: MonthlyRent): string => {
  switch (monthlyRent) {
    case 10000:
      return "0 - 10 000 kr";
    case 15000:
      return "10 000 - 15 000 kr";
    case 20000:
      return "15 000 - 20 000 kr";
    case 30000:
      return "20 000 - 30 000 kr";
    case 40000:
      return "30 000 - 40 000 kr";
    default:
      return "";
  }
};
